import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _67b1379c = () => interopDefault(import('../pages/copyright.vue' /* webpackChunkName: "pages/copyright" */))
const _3f8cb6eb = () => interopDefault(import('../pages/cp/index.vue' /* webpackChunkName: "pages/cp/index" */))
const _05e250ed = () => interopDefault(import('../pages/donate/index.vue' /* webpackChunkName: "pages/donate/index" */))
const _13bf9baf = () => interopDefault(import('../pages/favorites/index.vue' /* webpackChunkName: "pages/favorites/index" */))
const _fba3dafc = () => interopDefault(import('../pages/film/index.vue' /* webpackChunkName: "pages/film/index" */))
const _05662e24 = () => interopDefault(import('../pages/popular.vue' /* webpackChunkName: "pages/popular" */))
const _1bd9abc6 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _77a4507e = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _1c25b59d = () => interopDefault(import('../pages/signin.vue' /* webpackChunkName: "pages/signin" */))
const _4cde9118 = () => interopDefault(import('../pages/success.vue' /* webpackChunkName: "pages/success" */))
const _08a22824 = () => interopDefault(import('../pages/termsofuse.vue' /* webpackChunkName: "pages/termsofuse" */))
const _68a91e66 = () => interopDefault(import('../pages/unsubscribe.vue' /* webpackChunkName: "pages/unsubscribe" */))
const _c9719d62 = () => interopDefault(import('../pages/cp/chat.vue' /* webpackChunkName: "pages/cp/chat" */))
const _77c9066b = () => interopDefault(import('../pages/cp/comments.vue' /* webpackChunkName: "pages/cp/comments" */))
const _fb854ff0 = () => interopDefault(import('../pages/cp/desc.vue' /* webpackChunkName: "pages/cp/desc" */))
const _8fb5adb4 = () => interopDefault(import('../pages/cp/donate.vue' /* webpackChunkName: "pages/cp/donate" */))
const _3f183908 = () => interopDefault(import('../pages/cp/feedback.vue' /* webpackChunkName: "pages/cp/feedback" */))
const _251f5e16 = () => interopDefault(import('../pages/cp/kino.vue' /* webpackChunkName: "pages/cp/kino" */))
const _05b2c57f = () => interopDefault(import('../pages/cp/streamers.vue' /* webpackChunkName: "pages/cp/streamers" */))
const _6831cc83 = () => interopDefault(import('../pages/cp/unsubs.vue' /* webpackChunkName: "pages/cp/unsubs" */))
const _63e853e6 = () => interopDefault(import('../pages/cp/vmeste.vue' /* webpackChunkName: "pages/cp/vmeste" */))
const _e7096974 = () => interopDefault(import('../pages/profile/favorites.vue' /* webpackChunkName: "pages/profile/favorites" */))
const _73f2e8c3 = () => interopDefault(import('../pages/profile/history.vue' /* webpackChunkName: "pages/profile/history" */))
const _66e28452 = () => interopDefault(import('../pages/favorites/_id.vue' /* webpackChunkName: "pages/favorites/_id" */))
const _36d61c6d = () => interopDefault(import('../pages/film/_id/index.vue' /* webpackChunkName: "pages/film/_id/index" */))
const _8cd554b2 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/copyright",
    component: _67b1379c,
    name: "copyright"
  }, {
    path: "/cp",
    component: _3f8cb6eb,
    name: "cp"
  }, {
    path: "/donate",
    component: _05e250ed,
    name: "donate"
  }, {
    path: "/favorites",
    component: _13bf9baf,
    name: "favorites"
  }, {
    path: "/film",
    component: _fba3dafc,
    name: "film"
  }, {
    path: "/popular",
    component: _05662e24,
    name: "popular"
  }, {
    path: "/privacy",
    component: _1bd9abc6,
    name: "privacy"
  }, {
    path: "/profile",
    component: _77a4507e,
    name: "profile"
  }, {
    path: "/signin",
    component: _1c25b59d,
    name: "signin"
  }, {
    path: "/success",
    component: _4cde9118,
    name: "success"
  }, {
    path: "/termsofuse",
    component: _08a22824,
    name: "termsofuse"
  }, {
    path: "/unsubscribe",
    component: _68a91e66,
    name: "unsubscribe"
  }, {
    path: "/cp/chat",
    component: _c9719d62,
    name: "cp-chat"
  }, {
    path: "/cp/comments",
    component: _77c9066b,
    name: "cp-comments"
  }, {
    path: "/cp/desc",
    component: _fb854ff0,
    name: "cp-desc"
  }, {
    path: "/cp/donate",
    component: _8fb5adb4,
    name: "cp-donate"
  }, {
    path: "/cp/feedback",
    component: _3f183908,
    name: "cp-feedback"
  }, {
    path: "/cp/kino",
    component: _251f5e16,
    name: "cp-kino"
  }, {
    path: "/cp/streamers",
    component: _05b2c57f,
    name: "cp-streamers"
  }, {
    path: "/cp/unsubs",
    component: _6831cc83,
    name: "cp-unsubs"
  }, {
    path: "/cp/vmeste",
    component: _63e853e6,
    name: "cp-vmeste"
  }, {
    path: "/profile/favorites",
    component: _e7096974,
    name: "profile-favorites"
  }, {
    path: "/profile/history",
    component: _73f2e8c3,
    name: "profile-history"
  }, {
    path: "/favorites/:id",
    component: _66e28452,
    name: "favorites-id"
  }, {
    path: "/film/:id",
    component: _36d61c6d,
    name: "film-id"
  }, {
    path: "/",
    component: _8cd554b2,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
